import ExecutionEnvironment from 'exenv';
export var getMobileDevice = function getMobileDevice() {
  if (!ExecutionEnvironment.canUseDOM) {
    return 'unknown';
  }

  var userAgent = navigator.userAgent || navigator.vendor || window.opera; // Windows Phone must come first because its UA also contains "Android"

  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  } // iOS detection from: http://stackoverflow.com/a/9039885/177710


  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
};
export var getMobileiOSBrowser = function getMobileiOSBrowser() {
  if (!ExecutionEnvironment.canUseDOM) {
    return 'unknown';
  }

  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    if (/CriOS/.test(userAgent)) {
      return 'Chrome';
    }

    return 'Safari';
  }

  return 'unknown';
};
export var getiOSDeviceType = function getiOSDeviceType() {
  if (!ExecutionEnvironment.canUseDOM) {
    return 'unknown';
  }

  if (getMobileDevice() === 'iOS') {
    if (screen.availHeight === 812 && screen.availWidth === 375) {
      return 'TALL';
    }

    return 'SHORT';
  }

  return 'unknown';
};